import React, { useEffect, useState, useRef } from "react";
import "./filtroIdeCort.css";
import "./main.js";
import lupa from "../../../assets/img/lupa.png";
import arrowDown from "../../../assets/img/flech_abaj.png";
import { useCounter } from "../../../hooks/useCounter";
import { useAxios } from "../../../hooks/useAxios";
import IdeaCortaTod from "../ideaCortaTod/IdeaCortaTod";
import ir from "../../../assets/img/ir_acti.png";
import ir2 from "../../../assets/img/ir_2.png";
import regresa from "../../../assets/img/regresa.png";
import regresa2 from "../../../assets/img/ir_izq.png";
import Modal from "../../../components/modal/Modal";
import InputIcon from "../../../components/inputIcon/InputIcon";
import { useTranslation } from "react-i18next";
import FilterInput from "../../../components/FilterInput/FilterInput.jsx";

// Assets - icons
import arrowDownIcon from "../../../assets/img/flech_abaj.png";
import FilterMenu from "../../../components/FilterMenu/FilterMenu.jsx";

import {useOutsideClick} from "../../../hooks/useOutsideClick";

<script
  src="https://kit.fontawesome.com/2c36e9b7b1.js"
  crossorigin="anonymous"
></script>;

const pagin = [1, 2, 3, 4, 5, 6, 7, 8]; //, 9, 10];
const pagin_mov = [1, 2, 3, 4, 5];

const countIdaCort = 58;
const FiltroIdeCort = () => {
  const [t, i18n] = useTranslation("ideaCorta");
  const { counter, increment, decrement, resetCounter, defaultValue } =
    useCounter(0);
  const [ficha, setFicha] = useState(8);

  const [date, setDate] = useState(null);
  const [url, setUrl] = useState(
    `ideas/gnideas?offset=${counter * ficha}&next=800&lang=${i18n.language}`
  );
  const liga=`/${i18n.language}/Ideas-en-corto`
  const { data, isLoading } = useAxios(url);
  const [ide, setIde] = useState([]);

  const [showMobileOptions, setShowMobileOptions] = useState(false);
  
  const handleClickOutside = () => {
    setShowMobileOptions(false);
  }
  const inputSelectMobileRef = useOutsideClick(handleClickOutside);

  useEffect(() => {

   
      setUrl(
        `ideas/gnideas?offset=0&next=1000&lang=${i18n.language}`
      );
    
  }, [i18n.language]);
  
  const verYoutu = (ruta) => {
    window.open(ruta, "_blank");
  };

  const clase_mov = (index) => {
      return "card card1";
  };

  useEffect(() => {
    if (data) {
      setIde(data);
    }
  }, [data]);

  const renderizarMensaje_mov = (tipo, contenido, preview, index) => {
    
      if (tipo === "texto") {
        return (
          <div
            className="text1"
            dangerouslySetInnerHTML={{ __html: contenido }}
          ></div>
        );
      } else if (tipo === "imagen") {
        return (
          <div className="card-type-img">
            <img
              className="img1"
              src={"https://www.ricardosalinas.com" + preview}
              alt="Imagen ideas"
            />
          </div>
        );
      } else if (tipo === "texto-imagen") {
        return (
          <div className="div-txt-img">
            <button onClick={() => openModal(contenido, "")}>
              <img
                className="img1 "
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div className="cinta" onClick={() => openModal(contenido, "")}>
              <p className="tit_LB">Leer blog</p>
            </div>
          </div>
        );
      } else if (tipo === "texto-video") {
        return (
          <div className="div-txt-vid">
            <div className='playImageContainerMobile' onClick={() => openModal(contenido, "")}>
                <div className='arrow-right'/>
            </div>
            <button onClick={() => openModal(contenido, "")}>
              <img
                className="img1 "
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="div_bot_vid"
              onClick={() => openModal(contenido, "")}
            >
              
            </div>
          </div>
        );
      } else if (tipo === "carrete") {
        return (
          <div>
            <button onClick={() => openModal(contenido, "carrete")}>
              <img
                className="img1 "
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="cinta"
              onClick={() => openModal(contenido, "carrete")}
            >
              <p className="tit_LB">Ver galería</p>
            </div>
          </div>
        );
      } else if (tipo === "youtube") {
        return (
          <div className="div-youtube-list">
            {/* handleYoutubClick */}
            {/* <button onClick={() => openModal(contenido, '')}> */}

            <button className="stioYoutube" onClick={() => verYoutu(contenido)}>
              {/* <p> contenido</p> */}
              {/* <p>contenido</p> */}
              <img
                className="img1 img_text"
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
          </div>
        );
      } else if (tipo === "video") {
        return (
          <div className="div-youtube-list">
            {/* <button onClick={() => openModal(contenido, '')}> */}
            <button className="stioYoutube" onClick={() => verYoutu(contenido)}>
              <img
                className="img1 img_text"
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
          </div>
        );
      } else {
        return <p>La condición es falsa</p>;
      }
    
    <InputIcon />;
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [variable1, setVariable1] = useState("");
  const [variable2, setVariable2] = useState("");

  const openModal = (value1, value2) => {
    setVariable1(value1);
    setVariable2(value2);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const options = [
    { value: 'Asce', label: 'Ascendente' },
    { value: 'Desc', label: 'Descendente' },
    // { value: 'custom', label: 'Personalizado' },
  ];

  const [inputVal, setInputVal] = useState("");

  const notAllowedChars = [
    '"',
    "`",
    "=",
    ";",
    "[",
    "]",
    "{",
    "}",
    "/",
    "\\",
    "&",
    "<",
    ">",
    ":",
    "'",
  ];

  const handleInputChange = (event) => {
    setInputVal(event.target.value);

    const value = event.target.value;

    // Verificar si el valor contiene algún carácter no permitido
    const containsNotAllowedChars = notAllowedChars.some((char) =>
      value.includes(char)
    );
    let cleanBody = "";

    if (containsNotAllowedChars) {
      event.target.classList.add("invalid");
      for (let character of inputVal) {
        cleanBody += notAllowedChars.includes(character) ? "" : character;
      }
      setInputVal(cleanBody);
    } else {
      event.target.classList.remove("invalid");
    }
  };

  //para movil
  const handleInputChange2 = (event) => {
    setInputVal(event.target.value);
  };

  const handleClick = () => {
    // Aquí puedes acceder al valor del input, que está en 'inputValue'
    if (inputVal.length <= 1) return;
    setFicha(8);
    setUrl(`ideas/searchbytitle?words=${inputVal}&lang=${i18n.language}`);
  };

  const handleClick2 = () => {
    // Aquí puedes acceder al valor del input, que está en 'inputValue'
    if (inputVal.length <= 1) return;
    setFicha(4);
    setUrl(
      `ideas/gnideas?offset=${counter * ficha}&next=8&lang=${i18n.language}`
    );
  };

  const handleYoutubClick = (variable3) => {
    return (
      <a class="buton_bp espac" target="_blank" href={variable3}>
        Blog{" "}
      </a>
    );
  };

  const ifButton = (blog_gruid, idioma) => {
    if (blog_gruid !== null) {
      // <div class="text1111" dangerouslySetInnerHTML={{ __html: item.contenido }} ></div>
      return (
        <a
          class="buton_bp espac"
          target="_blank"
          href={
            "https://www.ricardosalinas.com/blog/" + idioma + "/" + blog_gruid
          }
        >
          Blog{" "}
        </a>
      );
      // ${variable9}+ "/"${variable8}">blog</a>
    } else {
      return "";
    }
  };

  function handleDate() {
    if (inputVal.length === 0 && date === null) {
      setUrl(
        `ideas/gnideas?offset=0&next=8000&lang=${i18n.language}`
      );
    } else if (inputVal.length >= 1) {
      if (date != null) {
        setUrl(
          `/ideas/searchbytitle?words=${inputVal}&lang=${i18n.language}&sort=${date}`
        );
      } else {
        setUrl(`/ideas/searchbytitle?words=${inputVal}&lang=${i18n.language}`);
      }
    } else {
      setUrl(
        `ideas/gnideas?offset=0&next=8000&lang=${
          i18n.language
        }&sort=${date}`
      );
    }
  }

  const onClickSubmit = () => {

    handleDate();
  }

  const [optionSelected, setOptionSelected] = useState(null);

  const onChangeSortInput = (option) => {
    setOptionSelected(option);
    setDate(option?.value);
  }

  return (
    <div className="ideas-cort-FiIdeLi ideas-cort-FiIdeLi2">
      
      <div className="ideas-cort solo-tm-g">
        <div className="contenedor_IdeCort escritorio_idCorTod">
          <div className="row1_LB">
            <p className="result">
              {" "}
              {t("ideaCort.result1")} {ide.length} {t("ideaCort.result2")}
            </p>
            <br></br>
          </div>
          {isLoading && data === null ? (
            // (<div>    <h1>cargando...</h1></div>) :
            <div>
              {" "}
              <h1>{t("ideaCort.cargan")}</h1>
            </div>
          ) : (
            <IdeaCortaTod dataideas={ide} />
          )}
          
          <div className="row3_LB">
            <p className="result">
              {" "}
              {t("ideaCort.result1")} {ide.length} {t("ideaCort.result2")}
            </p>
          </div>
        </div>

        {/* aqui va lo de movil */}

        <div className="contenedor_IdeCort movil_idCorTod">
          
          <div className="row2_LB esc">
            <div className="list_content--items list_content--items_mov_tds">
              {ide.map((item, index) => (
                <div className={clase_mov(index)}>
                  <div className="div-card-1">
                    {renderizarMensaje_mov(
                      item.tipo,
                      item.contenido,
                      item.preview,
                      index
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="row3_LB">
            <p className="result">
              {" "}
              {t("ideaCort.result1")} {ide.length} {t("ideaCort.result2")}
            </p>
          </div>
        </div>

        <Modal
          isOpen={isModalOpen}
          closeModal={closeModal}
          variable1={variable1}
          variable2={variable2}
        />
 
        <div className="contenedor_IdeCort1 ">
          <div className="row4_LB">
            <div className="div_bot2_LB">
              <a className="buton2_LB" href={liga}>
                {t("ideaCort.regresar")}
              </a>
            </div>
          </div>
        </div><br></br>
      </div>
    </div>
  );
};
export default FiltroIdeCort;
